import React, { useState } from 'react';
import pdfDownloadIcon from '../assets/images/pdf-download.png';
import voirLeFichierIcon from '../assets/images/voir-le-fichier.png';
import reglementInterieurPdf from '../assets/documents/Règlement interieur 1.3.pdf';
import './InformationsUtiles.css';

const InformationsUtiles = () => {
  const [openModal, setOpenModal] = useState(null); // 'formation-complete' | 'evaluation' | 'horaires' | 'aac' | 'cs' | 'post-permis' | 'positionnement' | 'modalites' | null

  const handleDownload = (doc) => {
    if (doc.pdfFile) {
      const link = document.createElement('a');
      link.href = doc.pdfFile;
      link.download = doc.filename || doc.title + '.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const handleOpenModal = (modalType) => {
    setOpenModal(modalType);
  };

  const handleCloseModal = () => {
    setOpenModal(null);
  };

  const documents = [
    {
      id: 'evaluation-depart',
      title: "L'évaluation de départ",
      action: 'Voir',
      hasModal: true,
      modalType: 'evaluation'
    },
    {
      id: 'reglement-interieur',
      title: 'Le règlement intérieur',
      action: 'Télécharger',
      pdfFile: reglementInterieurPdf,
      filename: 'Règlement interieur 1.3.pdf'
    },
    {
      id: 'horaires-code',
      title: 'Horaires des cours de code',
      action: 'Voir',
      hasModal: true,
      modalType: 'horaires'
    },
    {
      id: 'formation-complete',
      title: 'Enjeux, déroulement et programme de formation',
      action: 'Voir',
      hasModal: true,
      modalType: 'formation-complete'
    },
    {
      id: 'programme-formation-accompagnee',
      title: 'Programme de formation conduite accompagnée',
      action: 'Voir',
      hasModal: true,
      modalType: 'aac'
    },
    {
      id: 'programme-formation-supervisee',
      title: 'Programme de formation conduite supervisée',
      action: 'Voir',
      hasModal: true,
      modalType: 'cs'
    },
    {
      id: 'formation-post-permis',
      title: 'Formation Post-permis',
      action: 'Voir',
      hasModal: true,
      modalType: 'post-permis'
    },
    {
      id: 'procede-positionnement',
      title: 'Procédé de positionnement',
      action: 'Voir',
      hasModal: true,
      modalType: 'positionnement'
    },
    {
      id: 'modalites-formations',
      title: "Modalités d'organisation des formations théoriques et pratiques",
      action: 'Voir',
      hasModal: true,
      modalType: 'modalites'
    }
  ];

  return (
    <section className="informations-utiles">
      <div className="container">
        <h2 className="section-title">Informations utiles</h2>
        <p className="informations-description">
          Retrouvez ici un ensemble de documents utiles pendant votre formation
        </p>
        <div className="documents-grid">
          {documents.map((doc) => (
            <div key={doc.id} className="document-card">
              <div className="document-content">
                <h3 className="document-title">{doc.title}</h3>
                <button 
                  className="btn-download-icon" 
                  type="button" 
                  aria-label={doc.hasModal ? `Voir ${doc.title}` : `Télécharger ${doc.title}`}
                  onClick={() => doc.hasModal ? handleOpenModal(doc.modalType) : handleDownload(doc)}
                >
                  <img 
                    src={doc.hasModal ? voirLeFichierIcon : pdfDownloadIcon} 
                    alt={doc.hasModal ? "Voir le fichier" : "Télécharger PDF"} 
                    className={`download-icon ${doc.hasModal ? 'download-icon-view' : ''}`}
                  />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Modal Formation complète */}
      {openModal === 'formation-complete' && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="modal-content-parcours" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={handleCloseModal} aria-label="Fermer">×</button>
            <h2 className="modal-title">Enjeux, déroulement et programme de formation</h2>
            
            <div className="modal-body">
              {/* Section Enjeux et déroulement */}
              <div className="formation-section">
                <div className="section-header">
                  <div className="section-icon">🎯</div>
                  <h3>Enjeux et déroulement de la formation</h3>
                </div>
                
                <div className="enjeux-intro">
                  <p className="intro-text">
                    L'automobile est devenue un <strong>outil social indispensable</strong> pour une très grande partie des jeunes de notre société. 
                    Au-delà du plaisir de conduire, l'utilisation d'une voiture est souvent indispensable pour les études, le travail ou les loisirs. 
                    <strong> Rouler en sécurité est donc une nécessité pour tous.</strong>
                  </p>
                  
                  <div className="info-box-modern">
                    <p className="intro-text">
                      Les conducteurs débutants représentent une part trop importante des tués et des blessés sur la route. 
                      L'effort engagé doit être poursuivi, notamment par le renforcement de l'éducation et de la formation.
                    </p>
                    <p className="intro-text">
                      Les accidents de la route ne sont pas liés à la fatalité. Le programme de formation au permis de conduire 
                      est mis en place pour aider les nouveaux conducteurs à se déplacer avec un <strong>risque faible de perdre la vie ou de la dégrader</strong>.
                    </p>
                  </div>

                  <div className="objectif-box">
                    <h4>Objectif général</h4>
                    <p>Amener tout automobiliste débutant à la maîtrise de compétences en termes de <strong>savoir-être</strong>, 
                    <strong> savoirs</strong>, <strong>savoir-faire</strong> et <strong>savoir-devenir</strong>.</p>
                  </div>

                  <p className="intro-text">
                    Apprendre à conduire est une <strong>démarche éducative exigeante</strong>. Le programme de formation se veut une vue d'ensemble 
                    des compétences qu'un conducteur responsable doit acquérir pour ne pas mettre sa sécurité et celle des autres en danger.
                  </p>

                  <p className="intro-text">
                    Vous allez apprendre à <strong>manipuler une automobile</strong> et à circuler dans différentes configurations, à en connaître 
                    les risques et les limites. Vous allez, au travers de ce programme, comprendre les règles du code de la route ainsi que 
                    l'influence des lois physiques, psychologiques et physiologiques. Vous devrez également vous situer personnellement 
                    en tant que citoyen dans vos choix de conduite.
                  </p>

                  <p className="intro-text">
                    Des <strong>cours théoriques et pratiques</strong>, collectifs ou individuels, vous aideront à atteindre les objectifs définis 
                    et à personnaliser votre progression. Votre formateur vous guidera et vous conseillera. Des tests de connaissances et de 
                    capacités pourront être mis en place au fur et à mesure.
                  </p>
                </div>
              </div>

              {/* Section Épreuve théorique */}
              <div className="formation-section">
                <div className="section-header">
                  <div className="section-icon">📝</div>
                  <h3>L'épreuve théorique générale (le code)</h3>
                </div>
                
                <div className="examen-section">
                  <div className="examen-info-box">
                    <p><strong>Pour préparer l'épreuve du code :</strong></p>
                    <ul className="examen-details">
                      <li>Il faut avoir <strong>au moins 16 ans</strong> si vous suivez la formation traditionnelle</li>
                      <li>Il faut avoir <strong>au moins 15 ans</strong> si vous suivez l'apprentissage anticipé de la conduite (AAC)</li>
                    </ul>
                  </div>

                  <p className="section-description">
                    Pour réussir cette épreuve, il faut obtenir <strong>au moins 35 bonnes réponses sur 40 questions</strong> (5 erreurs maximum). 
                    Une réponse est considérée comme juste si toutes les propositions exactes ont été validées.
                  </p>

                  <p className="section-description">
                    Parmi les 40 questions auxquelles vous devrez répondre, certaines sont en vidéo. Pendant le déroulé de la vidéo, 
                    pensez à évaluer l'intervalle de sécurité et à regarder tous les rétroviseurs.
                  </p>

                  <div className="info-box-modern">
                    <p className="intro-text">
                      <strong>Le jour de l'examen :</strong> pensez à apporter votre pièce d'identité et votre convocation.
                    </p>
                    <p className="intro-text">
                      <strong>Validité :</strong> votre code est valable pendant 5 ans.
                    </p>
                  </div>
                </div>
              </div>

              {/* Section Examen pratique */}
              <div className="formation-section">
                <div className="section-header">
                  <div className="section-icon">🚗</div>
                  <h3>L'examen pratique</h3>
                </div>
                
                <div className="examen-section">
                  <div className="examen-info-box">
                    <p><strong>Pour se présenter à l'épreuve pratique :</strong></p>
                    <ul className="examen-details">
                      <li>Il faut avoir <strong>au moins 17 ans</strong></li>
                      <li>Il faut avoir <strong>réussi l'examen du code</strong></li>
                    </ul>
                  </div>

                  <p className="section-description">
                    Cette épreuve dure <strong>environ 32 minutes</strong>. Elle a pour but de vérifier si vous êtes capable de conduire seul 
                    sans mettre en danger votre sécurité et celle des autres. Elle est évaluée par un expert, l'inspecteur du permis de conduire 
                    et de la sécurité routière.
                  </p>

                  <h4 className="examen-subtitle">Déroulement de l'épreuve</h4>
                  <p className="section-description">
                    Le jour de l'examen, l'épreuve vous est présentée individuellement par l'expert, qui vous précise ce que vous allez devoir faire :
                  </p>
                  
                  <div className="evaluation-grid">
                    <div className="evaluation-item">Réaliser un parcours empruntant des voies à caractère urbain, routier et/ou autoroutier</div>
                    <div className="evaluation-item">Suivre un itinéraire en vous guidant de manière autonome, pendant environ cinq minutes</div>
                    <div className="evaluation-item">Réaliser deux manœuvres différentes : un freinage pour un arrêt de précision et une manœuvre en marche arrière</div>
                    <div className="evaluation-item">Procéder à la vérification d'un élément technique à l'intérieur ou à l'extérieur du véhicule, répondre à une question en lien avec la sécurité routière, et répondre à une question sur les premiers secours</div>
                    <div className="evaluation-item">Appliquer les règles du code de la route, notamment les limitations de vitesse s'appliquant aux élèves conducteurs</div>
                    <div className="evaluation-item">Adapter votre conduite dans un souci d'économie de carburant et de limitation de rejet de gaz à effet de serre</div>
                    <div className="evaluation-item">Faire preuve de courtoisie envers les autres usagers et notamment les plus vulnérables</div>
                  </div>

                  <div className="examen-info-box">
                    <p><strong>L'évaluation réalisée par l'expert</strong> est basée sur des textes réglementaires et instructions précises qui en fixent les modalités.</p>
                    <p>Cette évaluation consiste en un bilan des compétences nécessaires et fondamentales devant être acquises pour une conduite en sécurité, 
                    car la conduite est un acte difficile qui engage une responsabilité forte.</p>
                    <p>À l'issue de l'épreuve, l'expert retranscrit de façon formelle le bilan de compétences dans une grille d'évaluation. 
                    Le Certificat d'Examen du Permis de Conduire, sur lequel est noté le résultat, vous est envoyé par courrier ou téléchargeable.</p>
                    <p><strong>En cas de réussite :</strong> le CEPC sera votre justificatif auprès des forces de l'ordre en attendant votre permis de conduire. 
                    Ce document est valable 4 mois maximum.</p>
                    <p><strong>En cas de réussite :</strong> vous serez en période probatoire avec 6 points sur votre permis de conduire.</p>
                  </div>
                </div>
              </div>

              {/* Section Programme de formation */}
              <div className="formation-section">
                <div className="section-header">
                  <div className="section-icon">📚</div>
                  <h3>Le programme de formation</h3>
                </div>
                
                <p className="section-description">
                  Le programme de formation est organisé autour de 4 compétences principales, chacune comprenant des compétences associées 
                  à acquérir progressivement.
                </p>

                <div className="competences-grid">
                  <div className="competence-card">
                    <h4>Compétence 1</h4>
                    <p className="competence-subtitle">Maîtriser le maniement du véhicule dans un trafic faible ou nul</p>
                    <ul>
                      <li>Connaître les principaux organes et commandes du véhicule, effectuer des vérifications intérieures et extérieures</li>
                      <li>Entrer, s'installer au poste de conduite et en sortir</li>
                      <li>Tenir, tourner le volant et maintenir la trajectoire</li>
                      <li>Démarrer et s'arrêter</li>
                      <li>Doser l'accélération et le freinage à diverses allures</li>
                      <li>Utiliser la boîte de vitesses</li>
                      <li>Diriger la voiture en avant en ligne droite et en courbe en adaptant allure et trajectoire</li>
                      <li>Regarder autour de soi et avertir</li>
                      <li>Effectuer une marche arrière et un demi-tour en sécurité</li>
                    </ul>
                  </div>

                  <div className="competence-card">
                    <h4>Compétence 2</h4>
                    <p className="competence-subtitle">Appréhender la route et circuler dans des conditions normales</p>
                    <ul>
                      <li>Rechercher la signalisation, les indices utiles et en tenir compte</li>
                      <li>Positionner le véhicule sur la chaussée et choisir la voie de circulation</li>
                      <li>Adapter l'allure aux situations</li>
                      <li>Tourner à droite et à gauche en agglomération</li>
                      <li>Détecter, identifier et franchir les intersections suivant le régime de priorité</li>
                      <li>Franchir les ronds-points et les carrefours à sens giratoire</li>
                      <li>S'arrêter et stationner en épi, en bataille et en créneau</li>
                    </ul>
                  </div>

                  <div className="competence-card">
                    <h4>Compétence 3</h4>
                    <p className="competence-subtitle">Circuler dans des conditions difficiles et partager la route avec les autres usagers</p>
                    <ul>
                      <li>Évaluer et maintenir les distances de sécurité</li>
                      <li>Croiser, dépasser, être dépassé</li>
                      <li>Passer des virages et conduire en déclivité</li>
                      <li>Connaître les caractéristiques des autres usagers et savoir se comporter à leur égard, avec respect et courtoisie</li>
                      <li>S'insérer, circuler et sortir d'une voie rapide</li>
                      <li>Conduire dans une file de véhicules et dans une circulation dense</li>
                      <li>Connaître les règles relatives à la circulation inter-files des motocyclistes. Savoir en tenir compte</li>
                      <li>Conduire quand l'adhérence et la visibilité sont réduites</li>
                      <li>Conduire à l'abord et dans la traversée d'ouvrages routiers tels que les tunnels, les ponts...</li>
                    </ul>
                  </div>

                  <div className="competence-card">
                    <h4>Compétence 4</h4>
                    <p className="competence-subtitle">Pratiquer une conduite autonome, sûre et économique</p>
                    <ul>
                      <li>Suivre un itinéraire de manière autonome</li>
                      <li>Préparer et effectuer un voyage longue distance en autonomie</li>
                      <li>Connaître les principaux facteurs de risque au volant et les recommandations à appliquer</li>
                      <li>Connaître les comportements à adopter en cas d'accident : protéger, alerter, secourir</li>
                      <li>Faire l'expérience des aides à la conduite du véhicule (régulateur, limiteur de vitesse, ABS, aides à la navigation...)</li>
                      <li>Avoir des notions sur l'entretien, le dépannage et les situations d'urgence</li>
                      <li>Pratiquer l'écoconduite</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal Évaluation de départ */}
      {openModal === 'evaluation' && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="modal-content-parcours" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={handleCloseModal} aria-label="Fermer">×</button>
            <h2 className="modal-title">Procédure d'évaluation de départ</h2>
            
            <div className="modal-body">
              <div className="evaluation-intro">
                <div className="info-box-modern">
                  <p className="intro-text">
                    Ce test se déroule en <strong>situation de conduite hors et en circulation</strong> à bord d'un véhicule-école.
                  </p>
                  <p className="intro-text">
                    Il permet de <strong>quantifier le nombre d'heures de formation</strong> à la conduite automobile. 
                    Il n'impose pas un nombre d'heures, c'est un <strong>prévisionnel</strong> qui pourra être revu à la baisse 
                    par l'implication de l'élève dans la formation, ainsi que par la fréquence des heures.
                  </p>
                  <p className="intro-text">
                    Cette évaluation permettra, en concertation avec l'école de conduite, d'<strong>organiser un calendrier de formation</strong>.
                  </p>
                  <p className="intro-text">
                    <strong>Durée :</strong> environ 45 minutes<br />
                    <strong>Référence :</strong> Guide pour la Formation des Automobilistes (GFA)
                  </p>
                </div>
              </div>

              <div className="evaluation-structure">
                <h3 className="section-subtitle">Structure de l'évaluation</h3>
                <p className="section-description">
                  L'évaluation se décompose en <strong>8 rubriques</strong> visant à la production d'un résultat codifié 
                  à 3 niveaux de performance (faible, satisfaisant, bon) conduisant à 3 tranches de propositions de volumes horaires.
                </p>
                
                <div className="rubriques-grid">
                  <div className="rubrique-item">
                    <div className="rubrique-number">1</div>
                    <div className="rubrique-content">
                      <h4>Renseignements d'ordre général</h4>
                      <p>Informations sur l'élève</p>
                    </div>
                  </div>
                  <div className="rubrique-item">
                    <div className="rubrique-number">2</div>
                    <div className="rubrique-content">
                      <h4>Expérience de la conduite</h4>
                      <p>Pratique et contexte de conduite</p>
                    </div>
                  </div>
                  <div className="rubrique-item">
                    <div className="rubrique-number">3</div>
                    <div className="rubrique-content">
                      <h4>Connaissance du véhicule</h4>
                      <p>Maîtrise technique</p>
                    </div>
                  </div>
                  <div className="rubrique-item">
                    <div className="rubrique-number">4</div>
                    <div className="rubrique-content">
                      <h4>Attitudes</h4>
                      <p>À l'égard de l'apprentissage et de la sécurité</p>
                    </div>
                  </div>
                  <div className="rubrique-item">
                    <div className="rubrique-number">5</div>
                    <div className="rubrique-content">
                      <h4>Habiletés</h4>
                      <p>Coordination et synchronisation des gestes</p>
                    </div>
                  </div>
                  <div className="rubrique-item">
                    <div className="rubrique-number">6</div>
                    <div className="rubrique-content">
                      <h4>Compréhension et mémoire</h4>
                      <p>Capacités cognitives</p>
                    </div>
                  </div>
                  <div className="rubrique-item">
                    <div className="rubrique-number">7</div>
                    <div className="rubrique-content">
                      <h4>Perception</h4>
                      <p>Observation et analyse de l'environnement</p>
                    </div>
                  </div>
                  <div className="rubrique-item">
                    <div className="rubrique-number">8</div>
                    <div className="rubrique-content">
                      <h4>Émotivité</h4>
                      <p>Réactions et gestion du stress</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="competences-detail">
                <h3 className="section-subtitle">Détail des compétences évaluées</h3>
                
                <div className="competence-section">
                  <div className="competence-header">
                    <span className="competence-letter">A</span>
                    <h4>Renseignements d'ordre général</h4>
                  </div>
                  <p className="competence-description">
                    Sur la base d'un questionnaire et d'un échange avec le formateur : identité, âge, résidence, 
                    niveau scolaire, profession, nationalité, acuité visuelle, correction de la vision, visite médicale, 
                    incompatibilités déclarées.
                  </p>
                  <p className="competence-note">
                    Ces critères n'entraînent pas de chiffrage, mais permettent de donner des orientations au formateur 
                    sur les difficultés éventuelles de compréhension de la langue française. De plus, ils permettent 
                    éventuellement de dépister des déficiences sensorielles ou motrices et de proposer une visite médicale 
                    ou de suggérer un simple appareillage de la vue par exemple.
                  </p>
                </div>

                <div className="competence-section">
                  <div className="competence-header">
                    <span className="competence-letter">B</span>
                    <h4>Expérience de la conduite</h4>
                  </div>
                  <p className="competence-description">
                    Sur la base d'un questionnaire :
                  </p>
                  <ul className="competence-list">
                    <li>Permis possédés</li>
                    <li>Véhicules conduits</li>
                    <li>Zone d'évolution à bord du véhicule</li>
                    <li>Temps de pratique en conduite</li>
                    <li>Contexte d'accompagnement ou pratique autonome</li>
                  </ul>
                </div>

                <div className="competence-section">
                  <div className="competence-header">
                    <span className="competence-letter">C</span>
                    <h4>Connaissances théoriques sur le véhicule</h4>
                  </div>
                  <p className="competence-description">
                    Capacité à répondre à un QCM à 3 propositions sur une série de 12 questions déclinées en 4 thèmes techniques :
                  </p>
                  <div className="themes-list-inline">
                    <span className="theme-tag">Direction</span>
                    <span className="theme-tag">Boîte de vitesses</span>
                    <span className="theme-tag">Embrayage</span>
                    <span className="theme-tag">Freinage</span>
                  </div>
                </div>

                <div className="competence-section">
                  <div className="competence-header">
                    <span className="competence-letter">D</span>
                    <h4>Attitudes à l'égard de la sécurité et de l'apprentissage</h4>
                  </div>
                  <div className="attitudes-grid">
                    <div className="attitude-item">
                      <h5>Attitudes à l'égard de la sécurité</h5>
                      <p>Sur la base d'un entretien, hiérarchisation des attitudes : limitation aux aspects techniques et réglementaires 
                      de la conduite <strong>versus</strong> adaptation au contexte et partage de l'espace routier.</p>
                    </div>
                    <div className="attitude-item">
                      <h5>Motivation à l'apprentissage</h5>
                      <p>Sur la base d'un entretien, repérage de la motivation : par choix et motivation interne 
                      <strong> versus</strong> motivation externe et nécessité.</p>
                    </div>
                  </div>
                </div>

                <div className="competence-section">
                  <div className="competence-header">
                    <span className="competence-letter">E</span>
                    <h4>Habiletés (coordination et synchronisation des gestes)</h4>
                  </div>
                  <p className="competence-description">Hors circulation :</p>
                  <ul className="competence-list">
                    <li><strong>Installation au poste de conduite</strong> sur un poste de conduite déréglé en autonomie sur invitation du formateur</li>
                    <li><strong>5 réalisations de « départ arrêt »</strong> sur terrain plat à la suite d'une démonstration commentée du formateur</li>
                    <li><strong>Manipulation du volant :</strong> après explications sur le fait que le regard précède la trajectoire et l'action sur le volant, 
                    l'élève exécute un slalom non matérialisé sans utiliser les pédales</li>
                  </ul>
                </div>

                <div className="competence-section">
                  <div className="competence-header">
                    <span className="competence-letter">F</span>
                    <h4>Compréhension et mémorisation</h4>
                  </div>
                  <div className="comprehension-grid">
                    <div className="comprehension-item">
                      <h5>Compréhension</h5>
                      <p>Nécessité d'avoir recours à des explications ou démonstrations supplémentaires durant les exercices concernant les habiletés.</p>
                    </div>
                    <div className="comprehension-item">
                      <h5>Mémorisation</h5>
                      <p>Capacité à citer dans l'ordre les 5 opérations nécessaires pour démarrer et s'arrêter.</p>
                    </div>
                  </div>
                </div>

                <div className="competence-section">
                  <div className="competence-header">
                    <span className="competence-letter">G</span>
                    <h4>Perception</h4>
                  </div>
                  <p className="competence-description">
                    <strong>En circulation :</strong> À allure normale, en ville sur route, pendant environ 15 à 20 minutes, 
                    en doubles commandes (autonomie : volant, clignotants, rétroviseurs), l'élève devra :
                  </p>
                  <ul className="competence-list">
                    <li>Choisir sa direction en fonction de ce que lui impose la signalisation (4 à 5 fois)</li>
                    <li>Choisir sa direction en fonction des indications données par les panneaux directionnels (4 à 5 fois)</li>
                    <li>Regarder loin devant lui et faire attention à gauche et à droite</li>
                    <li>Tenir compte de la signalisation et des autres usagers</li>
                    <li>Mettre le clignotant si nécessaire</li>
                    <li>Dire le plus tôt possible ce qui lui semble intéressant pour la conduite</li>
                  </ul>
                  <p className="competence-note">
                    <strong>Compétences évaluées :</strong> sens de la trajectoire et du gabarit, capacité d'observation de l'environnement, 
                    sens de l'orientation et direction du regard.
                  </p>
                </div>

                <div className="competence-section">
                  <div className="competence-header">
                    <span className="competence-letter">H</span>
                    <h4>Émotivité</h4>
                  </div>
                  <p className="competence-description">
                    Les réactions émotives sont évaluées pendant toute la durée de l'évaluation.
                  </p>
                  <div className="emotivite-grid">
                    <div className="emotivite-item">
                      <h5>Réactions générales</h5>
                      <p>Paroles et gestes divers</p>
                    </div>
                    <div className="emotivite-item">
                      <h5>Crispations gestuelles</h5>
                      <p>Observation des tensions et crispations</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal Horaires des cours de code */}
      {openModal === 'horaires' && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="modal-content-parcours" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={handleCloseModal} aria-label="Fermer">×</button>
            <h2 className="modal-title">Horaires des cours théoriques</h2>
            
            <div className="modal-body">
              <div className="horaires-intro">
                <div className="info-box-modern">
                  <p className="intro-text">
                    Les cours théoriques sont dispensés dans les locaux de l'école de conduite par un 
                    <strong> enseignant de la conduite et de la sécurité routière</strong> titulaire d'une autorisation d'enseigner en cours de validité.
                  </p>
                </div>
              </div>

              <div className="horaires-section">
                <h3 className="section-subtitle">Planning hebdomadaire</h3>
                <div className="horaires-table-container">
                  <table className="horaires-table">
                    <thead>
                      <tr>
                        <th>Lundi</th>
                        <th>Mardi</th>
                        <th>Mercredi</th>
                        <th>Jeudi</th>
                        <th>Vendredi</th>
                        <th>Samedi</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="no-horaire">-</td>
                        <td>
                          <div className="horaire-slot">10h00 - 12h00</div>
                          <div className="horaire-slot">15h00 - 19h00</div>
                        </td>
                        <td>
                          <div className="horaire-slot">10h00 - 12h00</div>
                          <div className="horaire-slot">15h00 - 19h00</div>
                        </td>
                        <td>
                          <div className="horaire-slot">10h00 - 12h00</div>
                          <div className="horaire-slot">15h00 - 19h00</div>
                        </td>
                        <td>
                          <div className="horaire-slot">10h00 - 12h00</div>
                          <div className="horaire-slot">15h00 - 19h00</div>
                        </td>
                        <td>
                          <div className="horaire-slot">10h00 - 12h00</div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="thematiques-section">
                <h3 className="section-subtitle">Thématiques traitées</h3>
                <p className="section-description">
                  Les cours théoriques abordent les thèmes essentiels pour une conduite responsable et sécurisée :
                </p>
                <div className="thematiques-grid">
                  <div className="thematique-item">
                    <div className="thematique-icon">🍷</div>
                    <div className="thematique-content">
                      <h4>Alcool, drogues et médicaments</h4>
                      <p>Les effets dus à la consommation d'alcool, de drogues et de médicaments sur la conduite</p>
                    </div>
                  </div>
                  <div className="thematique-item">
                    <div className="thematique-icon">😴</div>
                    <div className="thematique-content">
                      <h4>Fatigue</h4>
                      <p>L'influence de la fatigue sur la conduite et les risques associés</p>
                    </div>
                  </div>
                  <div className="thematique-item">
                    <div className="thematique-icon">🌧️</div>
                    <div className="thematique-content">
                      <h4>Conditions météorologiques</h4>
                      <p>Les risques liés aux conditions météorologiques et aux états de la chaussée</p>
                    </div>
                  </div>
                  <div className="thematique-item">
                    <div className="thematique-icon">🚶</div>
                    <div className="thematique-content">
                      <h4>Usagers vulnérables</h4>
                      <p>La protection et le partage de l'espace routier avec les usagers vulnérables</p>
                    </div>
                  </div>
                  <div className="thematique-item">
                    <div className="thematique-icon">👥</div>
                    <div className="thematique-content">
                      <h4>Pression sociale</h4>
                      <p>La pression sociale (publicité, travail...) et son impact sur la conduite</p>
                    </div>
                  </div>
                  <div className="thematique-item">
                    <div className="thematique-icon">👫</div>
                    <div className="thematique-content">
                      <h4>Pression des pairs</h4>
                      <p>L'influence de la pression des pairs sur les comportements au volant</p>
                    </div>
                  </div>
                </div>
                
                <div className="thematiques-important">
                  <h4 className="important-title">Points de vigilance</h4>
                  <div className="important-tags">
                    <span className="important-tag">Alcool et stupéfiants</span>
                    <span className="important-tag">Vitesse</span>
                    <span className="important-tag">Défaut de port de la ceinture de sécurité</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal Programme de formation conduite accompagnée */}
      {openModal === 'aac' && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="modal-content-parcours" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={handleCloseModal} aria-label="Fermer">×</button>
            <h2 className="modal-title">Programme de formation conduite accompagnée</h2>
            
            <div className="modal-body">
              {/* Introduction */}
              <div className="aac-intro">
                <div className="info-box-modern">
                  <h3 className="aac-subtitle">Se former dans la durée</h3>
                  <p className="intro-text">
                    <strong>Dès 15 ans</strong>, vous pouvez choisir la conduite accompagnée. Cette formation se déroule en <strong>2 phases distinctes</strong> 
                    pour vous permettre d'acquérir progressivement les compétences nécessaires à une conduite sûre et responsable.
                  </p>
                </div>
              </div>

              {/* Phase 1 */}
              <div className="formation-section">
                <div className="section-header">
                  <div className="section-icon">1️⃣</div>
                  <h3>Phase 1 : Période de formation initiale</h3>
                </div>
                
                <p className="section-description">
                  Avant de pouvoir conduire avec un accompagnateur, la formation initiale comprend :
                </p>

                <div className="phase-items">
                  <div className="phase-item">
                    <span className="phase-check">✓</span>
                    <p>Une <strong>évaluation préalable</strong> (1h)</p>
                  </div>
                  <div className="phase-item">
                    <span className="phase-check">✓</span>
                    <p>Une <strong>formation théorique</strong> pour la préparation à l'épreuve théorique générale, dite épreuve du « code »</p>
                  </div>
                  <div className="phase-item">
                    <span className="phase-check">✓</span>
                    <p>Une <strong>formation pratique</strong> (cours de conduite) d'<strong>au moins 20 heures</strong></p>
                  </div>
                </div>

                <div className="info-box-modern">
                  <p className="intro-text">
                    Une fois l'<strong>épreuve du code obtenue</strong> et le niveau de conduite jugé satisfaisant par l'enseignant, 
                    celui-ci délivre une <strong>attestation de fin de formation initiale (AFFI)</strong>.
                  </p>
                  <p className="intro-text">
                    Cette attestation est consignée dans le <strong>livret d'apprentissage numérique</strong>. Elle est aussi remise à la 
                    compagnie d'assurances, car elle est <strong>indispensable pour commencer la conduite accompagnée</strong>.
                  </p>
                </div>
              </div>

              {/* Phase 2 */}
              <div className="formation-section">
                <div className="section-header">
                  <div className="section-icon">2️⃣</div>
                  <h3>Phase 2 : Période de conduite accompagnée</h3>
                </div>
                
                <p className="section-description">
                  La phase de conduite accompagnée débute par un <strong>rendez-vous préalable d'une durée minimale de 2 heures</strong>.
                </p>

                <p className="section-description">
                  Il réunit l'élève, installé au poste de conduite, l'enseignant à ses côtés et l'accompagnateur assis à l'arrière, 
                  afin de réaliser le « passage de relais » entre l'enseignant de la conduite et l'accompagnateur.
                </p>

                <p className="section-description">
                  À la fin de cette séance, un <strong>guide est remis à l'accompagnateur</strong>, dans lequel il trouvera les informations 
                  utiles à la formation du futur conducteur.
                </p>

                <div className="info-box-modern">
                  <p className="intro-text">
                    <strong>Cette phase de conduite dure 1 an au moins, sur 3 000 km au moins</strong>, en compagnie d'un ou plusieurs accompagnateur(s).
                  </p>
                  <p className="intro-text">
                    Au cours de cette phase, <strong>au moins 2 rendez-vous pédagogiques de 3h</strong> sont effectués 
                    (un 3ème rendez-vous pédagogique de 3h est facultatif).
                  </p>
                </div>
              </div>

              {/* Les accompagnateurs */}
              <div className="formation-section">
                <div className="section-header">
                  <div className="section-icon">👥</div>
                  <h3>Les accompagnateurs</h3>
                </div>
                
                <p className="section-description">Pour être accompagnateur, il faut :</p>

                <div className="accompagnateurs-list">
                  <div className="accompagnateur-item">
                    <span className="check-icon">✓</span>
                    <p>Être titulaire du permis B depuis <strong>au moins 5 ans sans interruption</strong></p>
                  </div>
                  <div className="accompagnateur-item">
                    <span className="check-icon">✓</span>
                    <p>Avoir <strong>l'accord de l'assureur</strong></p>
                  </div>
                  <div className="accompagnateur-item">
                    <span className="check-icon">✓</span>
                    <p>Ne pas avoir de condamnation pour certains délits (alcool, drogues, délit de fuite...)</p>
                  </div>
                  <div className="accompagnateur-item">
                    <span className="check-icon">✓</span>
                    <p>Être <strong>mentionné dans le contrat</strong> signé avec l'école de conduite</p>
                  </div>
                  <div className="accompagnateur-item">
                    <span className="check-icon">✓</span>
                    <p><strong>Participer au rendez-vous préalable</strong></p>
                  </div>
                </div>

                <p className="section-description">
                  <strong>Vous pouvez avoir plusieurs accompagnateurs</strong>, y compris hors du cadre familial.
                </p>
              </div>

              {/* Les avantages */}
              <div className="formation-section">
                <div className="section-header">
                  <div className="section-icon">✨</div>
                  <h3>Les avantages</h3>
                </div>

                <div className="avantages-aac-grid">
                  <div className="avantage-aac-card">
                    <div className="avantage-icon">💳</div>
                    <h4>L'assurance</h4>
                    <p><strong>Avantages tarifaires des compagnies d'assurances :</strong></p>
                    <ul>
                      <li>Surprime de la 1ère année <strong>diminuée de 50%</strong></li>
                      <li><strong>Suppression de la surprime</strong> la 2e année si vous n'avez occasionné aucun accident</li>
                    </ul>
                  </div>

                  <div className="avantage-aac-card">
                    <div className="avantage-icon">🎯</div>
                    <h4>Une meilleure réussite</h4>
                    <p>L'examen intervient dès <strong>17 ans</strong>, au terme d'une formation performante et après une année au moins de conduite accompagnée.</p>
                    <p><strong>Le taux de réussite à l'examen du permis de conduire est meilleur</strong> que celui correspondant à la formation classique : 
                    <strong> 75% de réussite contre 58%</strong> pour la filière traditionnelle.</p>
                  </div>

                  <div className="avantage-aac-card">
                    <div className="avantage-icon">⏰</div>
                    <h4>Permis probatoire</h4>
                    <p><strong>Période probatoire réduite à 2 ans</strong>, au lieu de 3 pour les conducteurs issus de la formation traditionnelle.</p>
                    <p>Si vous suivez une formation post-permis (entre le 6e et le 12e mois après l'obtention de votre permis), 
                    la période probatoire est réduite à <strong>1 an et demi</strong>.</p>
                    <p>Vous obtenez <strong>6 points</strong> à l'obtention du permis (+3 points par an pendant 2 ans sans infraction).</p>
                  </div>

                  <div className="avantage-aac-card">
                    <div className="avantage-icon">🛡️</div>
                    <h4>Moins d'accidents</h4>
                    <p>L'apprentissage anticipé de la conduite garantit une <strong>meilleure sécurité</strong>.</p>
                    <p><strong>Quatre fois moins d'accidents</strong> que les conducteurs issus de la formation traditionnelle au cours des premières années de conduite.</p>
                  </div>
                </div>
              </div>

              {/* Les étapes */}
              <div className="formation-section">
                <div className="section-header">
                  <div className="section-icon">📋</div>
                  <h3>Les étapes de la conduite accompagnée</h3>
                </div>

                <div className="etapes-aac">
                  <div className="etape-aac-item">
                    <div className="etape-aac-number">1</div>
                    <div className="etape-aac-content">
                      <h4>Inscription</h4>
                      <ul>
                        <li>Attestation d'inscription au permis</li>
                        <li>Livret d'apprentissage numérique</li>
                        <li>Lettre d'accord assurance</li>
                      </ul>
                    </div>
                  </div>

                  <div className="etape-aac-item">
                    <div className="etape-aac-number">2</div>
                    <div className="etape-aac-content">
                      <h4>Fin de formation initiale</h4>
                      <ul>
                        <li>Évaluation</li>
                        <li>Formation théorique</li>
                        <li>ETG (code)</li>
                        <li>Formation pratique</li>
                        <li>Bilan de compétences</li>
                        <li>Attestation de fin de formation initiale</li>
                        <li>Extension de garantie</li>
                      </ul>
                    </div>
                  </div>

                  <div className="etape-aac-item">
                    <div className="etape-aac-number">3</div>
                    <div className="etape-aac-content">
                      <h4>Conduite accompagnée</h4>
                      <p className="etape-duration"><strong>1 an / 3 000 km au moins</strong></p>
                      <ul>
                        <li>Rendez-vous préalable (2h)</li>
                        <li>1er Rendez-vous pédagogique (3h)</li>
                        <li>2ème Rendez-vous pédagogique (3h)</li>
                        <li>3ème Rendez-vous pédagogique (3h) - facultatif</li>
                      </ul>
                    </div>
                  </div>

                  <div className="etape-aac-item highlight">
                    <div className="etape-aac-number">4</div>
                    <div className="etape-aac-content">
                      <h4>Épreuve pratique</h4>
                      <p className="etape-duration"><strong>Dès 17 ans</strong></p>
                      <p>Permis probatoire : 6 points (+3 points par an pendant 2 ans sans infraction) + disque A</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Les règles */}
              <div className="formation-section">
                <div className="section-header">
                  <div className="section-icon">📜</div>
                  <h3>Les règles</h3>
                </div>
                
                <p className="section-description">
                  Pendant toute la période de conduite accompagnée, vous devez suivre les règles suivantes :
                </p>

                <div className="regles-list">
                  <div className="regle-item">
                    <span className="regle-icon">🚫</span>
                    <p><strong>Ne pas franchir les frontières françaises</strong></p>
                  </div>
                  <div className="regle-item">
                    <span className="regle-icon">🚗</span>
                    <p>Véhicule équipé de <strong>2 rétroviseurs latéraux</strong> (l'accompagnateur peut ajouter un second rétroviseur droit 
                    et un second rétroviseur central pour mieux voir la circulation vers l'arrière)</p>
                  </div>
                  <div className="regle-item">
                    <span className="regle-icon">🔴</span>
                    <p><strong>Disque « conduite accompagnée »</strong> obligatoire</p>
                  </div>
                  <div className="regle-item">
                    <span className="regle-icon">⚡</span>
                    <p><strong>Vitesses maximales autorisées</strong> applicables aux conducteurs novices (titulaires d'un permis probatoire)</p>
                  </div>
                </div>

                <div className="vitesses-section">
                  <h4 className="vitesses-title">Vitesses maximales autorisées</h4>
                  <div className="vitesses-grid">
                    <div className="vitesse-card">
                      <div className="vitesse-value">110 km/h</div>
                      <p className="vitesse-desc">Sur les sections d'autoroute limitées à 110 km/h</p>
                    </div>
                    <div className="vitesse-card">
                      <div className="vitesse-value">100 km/h</div>
                      <p className="vitesse-desc">Sur les routes à accès réglementé</p>
                    </div>
                    <div className="vitesse-card">
                      <div className="vitesse-value">80 km/h</div>
                      <p className="vitesse-desc">Sur les autres routes</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Documents obligatoires */}
              <div className="formation-section">
                <div className="section-header">
                  <div className="section-icon">📄</div>
                  <h3>Documents obligatoires</h3>
                </div>
                
                <p className="section-description">
                  Pendant la phase de conduite accompagnée, vous devez avoir en ma possession :
                </p>

                <div className="documents-list">
                  <div className="document-item">
                    <span className="document-icon">📋</span>
                    <span className="document-text">Votre attestation d'inscription au permis de conduire</span>
                  </div>
                  <div className="document-item">
                    <span className="document-icon">📋</span>
                    <span className="document-text">Le livret d'apprentissage numérique contenant l'attestation de fin de formation initiale, 
                    ainsi que la lettre-avenant signée par l'assurance</span>
                  </div>
                  <div className="document-item">
                    <span className="document-icon">📋</span>
                    <span className="document-text">Le disque « Conduite Accompagnée » apposé à l'arrière du véhicule</span>
                  </div>
                  <div className="document-item">
                    <span className="document-icon">📋</span>
                    <span className="document-text">Le permis de conduire de l'accompagnateur</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal Programme de formation conduite supervisée */}
      {openModal === 'cs' && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="modal-content-parcours" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={handleCloseModal} aria-label="Fermer">×</button>
            <h2 className="modal-title">Programme de formation conduite supervisée</h2>
            
            <div className="modal-body">
              {/* Introduction */}
              <div className="aac-intro">
                <div className="info-box-modern">
                  <h3 className="aac-subtitle">Plus souple que l'AAC</h3>
                  <p className="intro-text">
                    <strong>Dès 18 ans</strong>, vous pouvez choisir la conduite supervisée. Cette formule plus flexible vous permet de compléter 
                    votre formation initiale par une phase de conduite supervisée pour acquérir davantage d'expériences, 
                    afin de passer ensuite l'épreuve pratique dans des conditions sereines.
                  </p>
                  <p className="intro-text">
                    Vous pouvez opter pour la conduite supervisée <strong>dès la signature du contrat de formation</strong> 
                    ou <strong>après l'obtention de l'attestation de fin de formation initiale</strong>.
                  </p>
                </div>
              </div>

              {/* Formation initiale */}
              <div className="formation-section">
                <div className="section-header">
                  <div className="section-icon">📚</div>
                  <h3>Formation initiale</h3>
                </div>
                
                <p className="section-description">
                  Comme pour la conduite accompagnée, vous devez au préalable avoir <strong>réussi l'épreuve du code</strong> et avoir suivi 
                  <strong> au moins 20 heures de conduite</strong> en école de conduite si vous vous formez sur une voiture ayant une boîte de vitesses manuelle.
                </p>

                <div className="info-box-modern">
                  <p className="intro-text">
                    Cette durée est <strong>abaissée à 13 heures</strong> si vous conduisez sur boîte automatique.
                  </p>
                  <p className="intro-text">
                    À la fin de la formation initiale, c'est <strong>l'enseignant qui vous autorise</strong> à opter pour la conduite supervisée 
                    en fonction de vos compétences et de vos comportements.
                  </p>
                </div>
              </div>

              {/* Rendez-vous préalable */}
              <div className="formation-section">
                <div className="section-header">
                  <div className="section-icon">👥</div>
                  <h3>Le rendez-vous préalable</h3>
                </div>
                
                <p className="section-description">
                  D'une <strong>durée minimale de 2 heures</strong>, le rendez-vous préalable consiste en une séquence de conduite sur un véhicule de l'établissement.
                </p>

                <div className="phase-items">
                  <div className="phase-item">
                    <span className="phase-check">✓</span>
                    <p>Il réunit l'élève, installé au poste de conduite, l'enseignant à ses côtés et l'accompagnateur assis à l'arrière, 
                    afin de réaliser le « passage de relais » entre l'enseignant de la conduite et l'accompagnateur.</p>
                  </div>
                  <div className="phase-item">
                    <span className="phase-check">✓</span>
                    <p>À la fin de cette séance, un <strong>guide est remis à l'accompagnateur</strong>, dans lequel il trouvera les informations 
                    utiles à la formation du futur conducteur.</p>
                  </div>
                </div>
              </div>

              {/* Les étapes */}
              <div className="formation-section">
                <div className="section-header">
                  <div className="section-icon">📋</div>
                  <h3>Les étapes de la conduite supervisée</h3>
                </div>

                <div className="etapes-aac">
                  <div className="etape-aac-item">
                    <div className="etape-aac-number">1</div>
                    <div className="etape-aac-content">
                      <h4>Inscription</h4>
                      <ul>
                        <li>Attestation d'inscription au permis de conduire</li>
                        <li>Livret d'apprentissage</li>
                        <li>Lettre d'accord assurance</li>
                      </ul>
                    </div>
                  </div>

                  <div className="etape-aac-item">
                    <div className="etape-aac-number">2</div>
                    <div className="etape-aac-content">
                      <h4>Fin de formation initiale</h4>
                      <ul>
                        <li>Évaluation</li>
                        <li>Formation théorique</li>
                        <li>ETG (code)</li>
                        <li>Formation pratique (20h minimum, 13h si boîte automatique)</li>
                        <li>Bilan de compétences</li>
                        <li>Attestation de fin de formation initiale</li>
                        <li>Extension de garantie</li>
                      </ul>
                    </div>
                  </div>

                  <div className="etape-aac-item">
                    <div className="etape-aac-number">3</div>
                    <div className="etape-aac-content">
                      <h4>Conduite supervisée</h4>
                      <ul>
                        <li>Rendez-vous préalable (2 heures de conduite)</li>
                        <li>Expérience de conduite jugée suffisante par l'enseignant</li>
                        <li>Phase de conduite supervisée avec accompagnateur</li>
                      </ul>
                    </div>
                  </div>

                  <div className="etape-aac-item highlight">
                    <div className="etape-aac-number">4</div>
                    <div className="etape-aac-content">
                      <h4>Épreuve pratique</h4>
                      <p className="etape-duration"><strong>Dès 18 ans</strong></p>
                      <p>Permis probatoire : <strong>6 points</strong> (+2 points par an pendant 3 ans sans infraction) + disque A</p>
                      <p>CEPC valable 4 mois</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Les accompagnateurs */}
              <div className="formation-section">
                <div className="section-header">
                  <div className="section-icon">👥</div>
                  <h3>Les accompagnateurs</h3>
                </div>
                
                <p className="section-description">Pour être accompagnateur, il faut :</p>

                <div className="accompagnateurs-list">
                  <div className="accompagnateur-item">
                    <span className="check-icon">✓</span>
                    <p>Être titulaire du permis B depuis <strong>au moins 5 ans sans interruption</strong></p>
                  </div>
                  <div className="accompagnateur-item">
                    <span className="check-icon">✓</span>
                    <p>Avoir <strong>l'accord de l'assureur</strong></p>
                  </div>
                  <div className="accompagnateur-item">
                    <span className="check-icon">✓</span>
                    <p>Ne pas avoir de condamnation pour certains délits (alcool, drogues, délit de fuite...)</p>
                  </div>
                  <div className="accompagnateur-item">
                    <span className="check-icon">✓</span>
                    <p>Être <strong>mentionné dans le contrat</strong> signé avec l'école de conduite</p>
                  </div>
                  <div className="accompagnateur-item">
                    <span className="check-icon">✓</span>
                    <p><strong>Participer au rendez-vous préalable</strong></p>
                  </div>
                </div>

                <p className="section-description">
                  <strong>Vous pouvez avoir plusieurs accompagnateurs</strong>, y compris hors du cadre familial.
                </p>
              </div>

              {/* L'assurance */}
              <div className="formation-section">
                <div className="section-header">
                  <div className="section-icon">💳</div>
                  <h3>L'assurance</h3>
                </div>
                
                <div className="info-box-modern">
                  <p className="intro-text">
                    L'<strong>accord préalable (extension de garantie) écrit de l'assureur est indispensable</strong>. 
                    Il permet de couvrir le ou les véhicules utilisés pour la conduite et ses occupants.
                  </p>
                </div>
              </div>

              {/* Les règles */}
              <div className="formation-section">
                <div className="section-header">
                  <div className="section-icon">📜</div>
                  <h3>Les règles</h3>
                </div>
                
                <p className="section-description">
                  Pendant toute la période de conduite supervisée :
                </p>

                <div className="regles-list">
                  <div className="regle-item">
                    <span className="regle-icon">🛣️</span>
                    <p>Vous conduisez sur le <strong>réseau routier et autoroutier du territoire national</strong> à différents moments du jour 
                    et de la nuit et par diverses conditions météorologiques</p>
                  </div>
                  <div className="regle-item">
                    <span className="regle-icon">🚗</span>
                    <p>Votre véhicule est équipé de <strong>2 rétroviseurs latéraux</strong> (l'accompagnateur peut ajouter un second rétroviseur droit 
                    et un second rétroviseur central pour mieux voir vers l'arrière)</p>
                  </div>
                  <div className="regle-item">
                    <span className="regle-icon">🔴</span>
                    <p>Vous devez ajouter le <strong>disque « conduite accompagnée »</strong> à l'arrière du véhicule</p>
                  </div>
                </div>

                <div className="vitesses-section">
                  <h4 className="vitesses-title">Vitesses maximales autorisées</h4>
                  <div className="vitesses-grid">
                    <div className="vitesse-card">
                      <div className="vitesse-value">110 km/h</div>
                      <p className="vitesse-desc">Sur les sections d'autoroute limitées à 110 km/h</p>
                    </div>
                    <div className="vitesse-card">
                      <div className="vitesse-value">100 km/h</div>
                      <p className="vitesse-desc">Sur les routes à accès réglementé</p>
                    </div>
                    <div className="vitesse-card">
                      <div className="vitesse-value">80 km/h</div>
                      <p className="vitesse-desc">Sur les autres routes</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Permis probatoire */}
              <div className="formation-section">
                <div className="section-header">
                  <div className="section-icon">⏰</div>
                  <h3>Permis probatoire</h3>
                </div>
                
                <div className="info-box-modern">
                  <p className="intro-text">
                    <strong>6 points</strong> à l'obtention du permis (+2 points par an pendant 3 ans sans infraction).
                  </p>
                  <p className="intro-text">
                    Période probatoire de <strong>3 ans</strong>. Conducteur novice : seuil d'alcoolémie à <strong>0,2 g/l</strong> (0 verre d'alcool).
                  </p>
                </div>
              </div>

              {/* Documents obligatoires */}
              <div className="formation-section">
                <div className="section-header">
                  <div className="section-icon">📄</div>
                  <h3>Documents obligatoires</h3>
                </div>
                
                <p className="section-description">
                  Lors de la conduite supervisée, vous devez avoir avec vous :
                </p>

                <div className="documents-list">
                  <div className="document-item">
                    <span className="document-icon">📋</span>
                    <span className="document-text">Votre attestation d'inscription au permis de conduire</span>
                  </div>
                  <div className="document-item">
                    <span className="document-icon">📋</span>
                    <span className="document-text">Le livret d'apprentissage contenant l'attestation de fin de formation initiale, 
                    ainsi que la lettre-avenant signée par l'assurance (le livret peut être dématérialisé)</span>
                  </div>
                  <div className="document-item">
                    <span className="document-icon">📋</span>
                    <span className="document-text">Le disque "Conduite Accompagnée" apposé à l'arrière du véhicule</span>
                  </div>
                  <div className="document-item">
                    <span className="document-icon">📋</span>
                    <span className="document-text">Le permis de conduire de l'accompagnateur</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal Formation Post-permis */}
      {openModal === 'post-permis' && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="modal-content-parcours" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={handleCloseModal} aria-label="Fermer">×</button>
            <h2 className="modal-title">Formation Post-permis</h2>
            
            <div className="modal-body">
              {/* Introduction */}
              <div className="aac-intro">
                <div className="info-box-modern">
                  <h3 className="aac-subtitle">Le rendez-vous Post-Permis</h3>
                  <p className="intro-text">
                    Cette formation Post-Permis s'adresse à tous les nouveaux conducteurs souhaitant un complément d'information 
                    liées au monde de l'automobile de près ou de loin. Elle permettra de <strong>mieux appréhender les dangers de la route</strong> 
                    et de <strong>diminuer l'impact de l'automobile dans l'environnement</strong>.
                  </p>
                  <p className="intro-text">
                    Cette formation s'inscrit dans le <strong>continuum éducatif du citoyen usager de la route</strong>.
                  </p>
                </div>
              </div>

              {/* À qui est-elle destinée */}
              <div className="formation-section">
                <div className="section-header">
                  <div className="section-icon">👤</div>
                  <h3>À qui est-elle destinée ?</h3>
                </div>
                
                <p className="section-description">
                  Seuls les conducteurs novices titulaires d'un <strong>premier permis auto (B ou B1) ou moto (A1 ou A2)</strong> obtenu 
                  depuis <strong>au moins 6 mois et maximum 12 mois</strong> peuvent prétendre à cette formation, qui s'effectue sur la base de volontariat.
                </p>

                <div className="info-box-modern">
                  <p className="intro-text">
                    <strong>Conditions requises :</strong> Vous devez également n'avoir commis <strong>aucune infraction</strong> ayant donné lieu à un retrait 
                    de points ou ayant entraîné une mesure de restriction ou de suspension de votre permis de conduire durant toute la durée 
                    de la période probatoire.
                  </p>
                </div>
              </div>

              {/* Les objectifs */}
              <div className="formation-section">
                <div className="section-header">
                  <div className="section-icon">🎯</div>
                  <h3>Les objectifs de la formation Post-Permis</h3>
                </div>

                <div className="objectifs-post-permis">
                  <div className="objectif-post-permis-card">
                    <div className="objectif-number">1</div>
                    <div className="objectif-content">
                      <h4>Conduire de manière plus sûre et moins risquée</h4>
                      <p>Ce stage permet d'engager à travers les différents thèmes abordés une <strong>prise de conscience sur le risque</strong> 
                      afin d'éviter un sentiment de surconfiance au moment où le jeune conducteur a acquis davantage d'assurance au volant.</p>
                      <div className="stat-box">
                        <p><strong>En effet, près d'un quart des accidents impliquent un conducteur novice</strong>, ayant moins de 2 ans de permis.</p>
                      </div>
                    </div>
                  </div>

                  <div className="objectif-post-permis-card highlight">
                    <div className="objectif-number">2</div>
                    <div className="objectif-content">
                      <h4>Réduire la période probatoire</h4>
                      <p>Le permis de conduire est probatoire et doté d'un <strong>capital de 6 points</strong> à son obtention. 
                      Au bout de 3 ans et si le conducteur n'a pas commis d'infraction entraînant le retrait de points, il obtient ses 12 points (2 points par an).</p>
                      <p>En suivant cette formation <strong>entre le 6e et le 12e mois</strong> après l'obtention du permis, la période probatoire se verra réduite :</p>
                      
                      <div className="cas-comparison">
                        <div className="cas-item">
                          <div className="cas-header">
                            <span className="cas-icon">🚗</span>
                            <h5>Cas n°1 : Conduite traditionnelle</h5>
                          </div>
                          <div className="cas-timeline">
                            <div className="timeline-item">
                              <div className="timeline-without">
                                <p className="timeline-label">Sans formation</p>
                                <p className="timeline-duration">3 ans pour obtenir 12 points</p>
                              </div>
                              <div className="timeline-arrow">→</div>
                              <div className="timeline-with">
                                <p className="timeline-label">Avec formation</p>
                                <p className="timeline-duration highlight-text"><strong>2 ans pour obtenir 12 points</strong></p>
                              </div>
                            </div>
                            <p className="cas-gain">Vous gagnez <strong>1 an</strong></p>
                          </div>
                        </div>

                        <div className="cas-item">
                          <div className="cas-header">
                            <span className="cas-icon">🚙</span>
                            <h5>Cas n°2 : Conduite accompagnée (AAC)</h5>
                          </div>
                          <div className="cas-timeline">
                            <div className="timeline-item">
                              <div className="timeline-without">
                                <p className="timeline-label">Sans formation</p>
                                <p className="timeline-duration">2 ans pour obtenir 12 points</p>
                              </div>
                              <div className="timeline-arrow">→</div>
                              <div className="timeline-with">
                                <p className="timeline-label">Avec formation</p>
                                <p className="timeline-duration highlight-text"><strong>1 an et demi pour obtenir 12 points</strong></p>
                              </div>
                            </div>
                            <p className="cas-gain">Vous gagnez <strong>6 mois</strong></p>
                          </div>
                        </div>
                      </div>

                      <div className="info-box-modern">
                        <p className="intro-text">
                          <strong>Condition :</strong> À condition de n'avoir commis aucune infraction donnant lieu à retrait de points.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Comment se déroule la formation */}
              <div className="formation-section">
                <div className="section-header">
                  <div className="section-icon">📅</div>
                  <h3>Comment se déroule cette formation complémentaire ?</h3>
                </div>
                
                <div className="deroulement-items">
                  <div className="deroulement-item">
                    <span className="deroulement-icon">👥</span>
                    <div className="deroulement-content">
                      <h5>Format collectif</h5>
                      <p>Formation <strong>collective</strong> afin de permettre un maximum d'échanges sur les expériences de conduite entre les conducteurs d'une même génération.</p>
                    </div>
                  </div>

                  <div className="deroulement-item">
                    <span className="deroulement-icon">⏰</span>
                    <div className="deroulement-content">
                      <h5>Durée</h5>
                      <p>Sa durée est limitée à <strong>une seule journée de 7 heures</strong>.</p>
                    </div>
                  </div>

                  <div className="deroulement-item">
                    <span className="deroulement-icon">👨‍🏫</span>
                    <div className="deroulement-content">
                      <h5>Enseignant spécialisé</h5>
                      <p>Un <strong>enseignant de la conduite spécialement formé</strong> sera responsable de l'animation de cette journée.</p>
                    </div>
                  </div>

                  <div className="deroulement-item">
                    <span className="deroulement-icon">📋</span>
                    <div className="deroulement-content">
                      <h5>Contenu réglementé</h5>
                      <p>Le contenu de la formation, élaboré par des spécialistes de la sécurité routière, fait l'objet d'un <strong>arrêté publié le 10 mai 2019</strong> 
                      qui précise le contenu, l'organisation et les modalités de délivrance de l'attestation de suivi de la formation complémentaire.</p>
                    </div>
                  </div>

                  <div className="deroulement-item highlight">
                    <span className="deroulement-icon">⭐</span>
                    <div className="deroulement-content">
                      <h5>Label qualité</h5>
                      <p>À noter que seules les auto-écoles disposant du <strong>label « Ecole conduite Qualité »</strong> délivré et reconnu par les services de l'État, 
                      macaron jaune, sont habilitées à les dispenser.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal Procédé de positionnement */}
      {openModal === 'positionnement' && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="modal-content-parcours" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={handleCloseModal} aria-label="Fermer">×</button>
            <h2 className="modal-title">Procédé de positionnement</h2>
            
            <div className="modal-body">
              <div className="aac-intro">
                <div className="info-box-modern">
                  <h3 className="aac-subtitle">L'identification des objectifs et l'adaptation des prestations</h3>
                  <p className="intro-text">
                    Lors d'un renseignement, le procédé suivant est respecté afin d'<strong>analyser au mieux la demande du client </strong>
                    et de proposer les prestations les plus adaptées à sa situation et à ses objectifs.
                  </p>
                </div>
              </div>

              <div className="formation-section">
                <div className="section-header">
                  <div className="section-icon">📋</div>
                  <h3>Notre procédé en 6 étapes</h3>
                </div>

                <div className="positionnement-flow">
                  <div className="positionnement-step">
                    <div className="positionnement-number">1</div>
                    <div className="positionnement-content">
                      <h4>Accueil du client</h4>
                      <p>Prise en charge et première prise de contact</p>
                    </div>
                  </div>

                  <div className="positionnement-step">
                    <div className="positionnement-number">2</div>
                    <div className="positionnement-content">
                      <h4>Analyse de la demande du client</h4>
                      <p>Évaluation de trois critères essentiels :</p>
                      <ul>
                        <li><strong>Âge</strong></li>
                        <li><strong>Situation professionnelle</strong></li>
                        <li><strong>Objectif de la demande</strong></li>
                      </ul>
                    </div>
                  </div>

                  <div className="positionnement-step highlight">
                    <div className="positionnement-number">3</div>
                    <div className="positionnement-content">
                      <h4>Proposition en fonction de l'analyse</h4>
                      <p>Élaboration d'une offre adaptée à votre profil et à vos besoins</p>
                    </div>
                  </div>

                  <div className="positionnement-step">
                    <div className="positionnement-number">4</div>
                    <div className="positionnement-content">
                      <h4>Réalisation d'un devis</h4>
                      <p>Établissement d'un devis personnalisé et détaillé</p>
                    </div>
                  </div>

                  <div className="positionnement-step">
                    <div className="positionnement-number">5</div>
                    <div className="positionnement-content">
                      <h4>Présentation des financements</h4>
                      <p>Information sur les solutions de financement disponibles</p>
                    </div>
                  </div>

                  <div className="positionnement-step">
                    <div className="positionnement-number">6</div>
                    <div className="positionnement-content">
                      <h4>Dossier d'inscription</h4>
                      <p>Finalisation et constitution de votre dossier d'inscription</p>
                    </div>
                  </div>
                </div>

                <div className="info-box-modern">
                  <p className="intro-text">
                    Ce procédé est disponible dans votre auto-école <strong>TOP CONDUITE</strong>.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal Modalités d'organisation des formations */}
      {openModal === 'modalites' && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="modal-content-parcours" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={handleCloseModal} aria-label="Fermer">×</button>
            <h2 className="modal-title">Modalités d'organisation des formations théoriques et pratiques</h2>
            
            <div className="modal-body">
              {/* Formation théorique */}
              <div className="formation-section">
                <div className="section-header">
                  <div className="section-icon">📚</div>
                  <h3>Formation théorique</h3>
                </div>
                
                <p className="section-description">
                  L'auto-école propose des <strong>cours thématiques</strong> et des <strong>tests d'évaluation en présentiel</strong>.
                </p>

                <div className="modalites-subsection">
                  <h4 className="subsection-title">Organisation et horaires des cours théoriques en présentiel</h4>
                  
                  <div className="modalites-items">
                    <div className="modalites-item">
                      <div className="modalites-item-header">1. Cours thématiques</div>
                      <p>Organisés en cours collectifs et/ou individuels :</p>
                      <ul>
                        <li>Les cours thématiques sont animés par un <strong>formateur diplômé</strong></li>
                        <li>Le programme des cours thématiques est répertorié à l'auto-école</li>
                      </ul>
                    </div>

                    <div className="modalites-item">
                      <div className="modalites-item-header">2. Tests d'évaluation</div>
                      <p>Organisés en cours collectifs et/ou individuels :</p>
                      <ul>
                        <li>Séries de <strong>40 questions</strong> conformes à l'examen du code de la route</li>
                      </ul>
                    </div>

                    <div className="info-box-modern">
                      <p className="intro-text">
                        <strong>Horaires des cours théoriques :</strong> Du mardi au vendredi de 14h00 à 18h00
                      </p>
                    </div>
                  </div>
                </div>

                <div className="modalites-subsection">
                  <h4 className="subsection-title">Cours théoriques sur application (KOPILOTE)</h4>
                  
                  <div className="modalites-items">
                    <div className="modalites-item">
                      <div className="modalites-item-header">Cours thématiques et contenus</div>
                      <ul>
                        <li>Séries thématiques de <strong>10 questions en nombre illimité</strong></li>
                        <li><strong>Tests d'évaluation</strong></li>
                        <li><strong>Examens blancs</strong> conformes à l'examen du code de la route</li>
                      </ul>
                    </div>

                    <p className="section-description">
                      <strong>Horaires :</strong> Les horaires sont libres. Vous pouvez utiliser votre smartphone, ordinateur ou tablette.
                    </p>

                    <p className="section-description">
                      L'auto-école peut suivre votre progression et vos résultats, ce qui permet lors des cours thématiques et tests d'évaluation en présentiel de <strong>renforcer les besoins</strong>.
                    </p>

                    <div className="themes-modalites-grid">
                      <div className="theme-modalite">Les règles de circulation routière</div>
                      <div className="theme-modalite">Le conducteur</div>
                      <div className="theme-modalite">La route</div>
                      <div className="theme-modalite">Les autres usagers</div>
                      <div className="theme-modalite">Les notions diverses</div>
                      <div className="theme-modalite">Les premiers secours</div>
                      <div className="theme-modalite">Prendre et quitter le véhicule</div>
                      <div className="theme-modalite">La mécanique et les équipements</div>
                      <div className="theme-modalite">La sécurité du passager et du véhicule</div>
                      <div className="theme-modalite">L'environnement</div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Formation pratique */}
              <div className="formation-section">
                <div className="section-header">
                  <div className="section-icon">🚗</div>
                  <h3>Formation pratique</h3>
                </div>
                
                <p className="section-description">
                  Les cours pratiques couvrent <strong>toutes les compétences de formation</strong> et se déroulent dans divers contextes : 
                  en agglomération, hors agglomération, sur autoroute/voies rapides, par temps de pluie et la nuit, en fonction des dates et heures de rendez-vous.
                </p>

                <div className="competences-modalites">
                  <div className="competence-modalite-item">
                    <span className="competence-badge">1</span>
                    <p>Maîtriser le maniement du véhicule dans un trafic faible ou nul</p>
                  </div>
                  <div className="competence-modalite-item">
                    <span className="competence-badge">2</span>
                    <p>Appréhender la route et circuler dans des conditions normales</p>
                  </div>
                  <div className="competence-modalite-item">
                    <span className="competence-badge">3</span>
                    <p>Circuler dans des conditions difficiles et partager la route avec les autres usagers</p>
                  </div>
                  <div className="competence-modalite-item">
                    <span className="competence-badge">4</span>
                    <p>Pratiquer une conduite autonome, sûre et économique</p>
                  </div>
                </div>

                <div className="modalites-subsection">
                  <h4 className="subsection-title">Organisation et horaires des cours pratiques</h4>
                  <div className="modalites-items">
                    <div className="modalites-item">
                      <ul>
                        <li>Les cours pratiques sont <strong>individuels</strong></li>
                        <li>Organisés <strong>du lundi au samedi de 8h00 à 20h00</strong></li>
                        <li>Les heures de conduite <strong>débutent devant l'auto-école</strong></li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="info-box-modern a-retenir">
                  <h4 className="retain-title">À retenir !</h4>
                  <p className="intro-text">
                    Pour la phase pratique, il est important de privilégier une <strong>régularité</strong> des leçons de conduite. 
                    Un rythme de <strong>4 heures par semaine</strong> est proposé pour une meilleure efficacité.
                  </p>
                  <p className="intro-text">
                    Des <strong>bilans de compétences</strong> seront effectués au cours de la formation et un <strong>examen blanc</strong> avant une proposition de date d'examen.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

    </section>
  );
};

export default InformationsUtiles;
